export default __webpack_public_path__ + "static/media/rar.36699bf0.png";